import React, { useState } from "react";
import { GetProForma } from "../../../../services/ReRegistrationService";
import Swal from "sweetalert2";
import {
  FileRowContainer,
  FileRowContent,
  FileRowLabel,
  FileRowDescription,
  FileRowButtonLink,
} from "../../SupportingDocuments/primitives";
function RequestProForma({ studentId }) {
  const [isLoading, setIsLoading] = useState(false);

  const handleRequestProforma = () => {
    setIsLoading(true);
    GetProForma(studentId).then((response) => {
      setIsLoading(false);
      if (response.data?.pdf?.pdf) {
        const base64 = response.data.pdf.pdf.replace(/\s/g, ''); // strip whitespace
        const byteArray = Uint8Array.from(atob(base64), c => c.charCodeAt(0));
        const blob = new Blob([byteArray], { type: 'application/pdf' });
        const blobUrl = URL.createObjectURL(blob);
        window.open(blobUrl, '_blank');
      } else {
        Swal.fire({
          icon: "error",
          title: "Error",
          text: response.data.error || "Failed to generate pro forma",
        });
      }
    }).catch(() => {
      setIsLoading(false);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Something went wrong",
      });
    });
  };

  return (
        <FileRowContainer
          onClick={!isLoading ? handleRequestProforma : undefined}
          $clickable={!isLoading}
        >
          <FileRowContent>
            <FileRowLabel>Pro Forma Invoice (Quote)</FileRowLabel>
           <FileRowDescription>Download a Pro-Forma Invoice (Quote) based on module selection, Full Payment discount will only reflect on the document once full payment has been received</FileRowDescription>
          </FileRowContent>
    
          <FileRowButtonLink
            onClick={!isLoading ? handleRequestProforma : undefined}
            $disabled={isLoading}
          >
            {isLoading ? <i className="fas fa-cog fa-spin"></i> : <i className="fal fa-download"></i>}
            Download
          </FileRowButtonLink>
        </FileRowContainer>
  );
}

export default React.memo(RequestProForma);